import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import telescope2 from '../assets/images/training.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';
 
class About extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${telescope2})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"Once a new technology rolls over you, if you're not part of the steamroller, you're part of the road."</p>
                <p>
                &mdash; Stewart Brand.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div></div>

            <div>
            <h1>Who We are</h1>
            <p>More than a year ago, we became very intrigued with the idea of creating functional, interactive websites and mobile applications for clients,
                and to also pass this knowledge across to willing minds. And then we launched.
            </p>
            <p>We offer individuals and bussiness owners reliable web design, mobile app design, app management and ICT training services. At Codeflare Limited, 
                we offer clients a more professional and a less risky way to develop their applications and turn their ideas into reality.
            </p>

            <h2>Need help?</h2>
            <p>
                Need to get technical help or enquiries about the services we offer?
                We'd be happy to chat with you. Anytime!
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default About;